import apiService from "./apiService";

export const getCartReportListService = (query) => {
  let queryParams = {
    page: query?.page ?? 1,
    item_per_page: 10,
    search_label: query?.item,
    count_sort_order: query?.sort
  }
  return apiService.get(URIS.cart, {params: queryParams})
}

const URIS = {
  cart: '/v1/pharmacy/cart-reporting',
}




